import { get, post } from '@/fn/ajax'
import { clean } from '@/fn/object'

export async function clientGroupList(data: any) {
    const res = await post('/api/classes/clientGroupList', data)
    return res
}

export async function addClientGroup(data: any) {
    const res = await post('/api/classes/addClientGroup', data)
    return res
}

export async function editClientGroup(data: any) {
    const res = await post('/api/classes/editClientGroup', data)
    return res
}
export async function delClientGroup(data: any) {
    const res = await post('/api/classes/delClientGroup', data)
    return res
}
export async function clientListByGroup(data: any) {
    const res = await post('/api/classes/clientListByGroup', data)
    return res
}
export async function addClientToGroup(data: any) {
    const res = await post('/api/classes/addClientToGroup', data)
    return res
}
export async function delClientByGroup(data: any) {
    const res = await post('/api/classes/delClientByGroup', data)
    return res
}




